import { 
    useGetExportDataMutation, 
    useGetForecastCustomerLevelDataMutation, 
    useGetInventoryAvailabilityDataMutation, 
    useGetScenarioPlanningDataMutation, 
    useGetStockOutAnddemandDataMutation, 
    useUpdateForecastDataMutation, 
    useUpdateReviewedForecastDataMutation } 
from "../api/forecastApi";

export const useScenarioPlanningData = () => {
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetScenarioPlanningDataMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    };
}

export const useStockOutAnddemandData = () => {
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetStockOutAnddemandDataMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    };
}


export const useInventoryAvailabilityData = () => {
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetInventoryAvailabilityDataMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    };
}


export const useUpdateReviewdForecastData = () => {
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useUpdateReviewedForecastDataMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    };
}


export const useGetForecastCustomerLevelData = () => {
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetForecastCustomerLevelDataMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    };
}


export const useGetExportData = () => {
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetExportDataMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    };
}

export const useUpdateForecast = () => {
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useUpdateForecastDataMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    };
}